import { useCallback } from 'react';
import { PageModel } from '@adobe/aem-react-editable-components';
import { ModuleProps } from '@quantum/tools/mfeModule';
import { useQuantumDispatch } from '@quantum/tools/redux';
import { MarkerProps } from '../types/Tile';
import { setTileStatus } from '../../../assembler-server/redux/analyticsSlice';
export const useDelayAnalytics = (props: { model: MarkerProps }) => {
  const dispatch = useQuantumDispatch();

  let path = '';
  if (typeof window !== 'undefined') {
    path = window.location.pathname;
    if (window.location.pathname.length > 1 && window.location.pathname.endsWith('/')) {
      path = path.slice(0, -1);
    }
  }

  const setTileReady = useCallback(
    (page: unknown) => {
      dispatch(setTileStatus({ tileName: props.model.markerName, page, path }));
    },
    [dispatch, props.model.markerName, path]
  );

  const tileProps = { ...props.model.tileProps, setTileReady } as ModuleProps;

  const model = { ...props.model, tileProps } as MarkerProps & PageModel;

  return { ...props, model };
};
